<template>
    <div class="fhv-centent" v-loading="loading" >
        <h4 class="title-topic">Mac Clone</h4>
          <el-form :model="pingForm" 
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="mini"
            :rules="checkPingForm"
            ref="pingForm"
            >
            <el-form-item>
                The MAC address currently used is {{macAddress}}
            </el-form-item>
            <el-form-item label="Manually change to another MAC address" prop="address">
                <el-input v-model="pingForm.address"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="setAddress">Clone</el-button>
                 <el-button type="primary" @click="recover">Recover</el-button>
            </el-form-item>
        </el-form>
    </div>
    
</template>

<script>

export default {
    data() {
        return {
            loading: false,
            wanLists:[],//wan连接列表
            internetWan:[],
            wanForm:[],
            macAddress:'',//当前mac地址
            macAddrString:'',
            cloneDisable:false,
            pingForm:{
                address:''
            },
            checkPingForm:{
                address:[
                    { required: true, message: 'mac cannot be empty.', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            console.log(value)
                            this.macAddrString = value.replace(/\s+/g,"");   
                            if (!validator.isMACAddress(this.macAddrString)) {
                                this.cloneDisable = true;
                                callback(
                                    new Error("MAC Address Error! e.g 00:0E:C6:DE:C7:99!")
                                );
                            } else {
                                this.cloneDisable = false;
                                callback();
                            }
                        },trigger: "blur"
                    }
                ]
            },
        }
    },
    created(){
        this.getMacAddress()
    },
    methods: {
        getMacAddress() {
            this.internetWan = [];
            this.loading = true
             axios
            .post("/boafrm/fhWANService",{CmdType:"GET_WAN"})
            .then((response)=>{
                this.loading = false               
                if(response.data.ret === 0)
                {
                    this.wanLists = response.data.wanLists;
                    if(this.wanLists.length){
                        this.wanLists.map(item=>{
                            if(item.serviceType==='0'||  item.serviceType==='1'){
                                this.internetWan.push(item);
                                return false
                            }
                        })
                        if(this.internetWan.length){
                            this.macAddress = this.formatString(this.internetWan[0].wan_macAddr);
                        }
                    }
                }
                else
                {
                    this.$message.error(`GET data failed! Error:${response.data.errorMsg}`)
                }
            })
        },
        setAddress(){
            if(this.internetWan.length===0){
                this.$message.error("Please add an Internet WAN connection")
            }else{
                if(this.pingForm.address && this.cloneDisable ===false){
                    let postData = JSON.parse( JSON.stringify( this.internetWan[0] ) );
                    let ipv6Addr = postData.ipv6.address.split('/');

                   this.macAddrString = (this.macAddrString).split(':').join('');
                    
                    postData.CmdType = "SET_WAN";
                    postData.bindPort =  postData.bindPort.join(',')                
                    postData.ipv6.address = ipv6Addr[0];
                    postData.ipv6.prefixLen = ipv6Addr[1] || 64;
                    postData.wan_macAddr = this.macAddrString;
                    
                    this.loading = true;
                    axios
                    .post("/boafrm/fhWANService",postData)
                    .then((response)=>{
                        this.loading = false                
                        if(response.data.ret === 0)
                        {
                            this.$message.success("Configuration is successful!")
                            this.getMacAddress()                        
                        }
                        else
                        {
                            this.$message.error("Configuration is failed!")
                        }
                    })  
                }  
            }       
        },
        recover(){
            if(this.internetWan.length===0){
                this.$message.error("Please add an Internet WAN connection")
            }else{
                let postData = JSON.parse( JSON.stringify( this.internetWan[0] ) );
                let ipv6Addr = postData.ipv6.address.split('/');
                
                postData.CmdType = "SET_WAN";
                postData.bindPort =  postData.bindPort.join(',')                
                postData.ipv6.address = ipv6Addr[0];
                postData.ipv6.prefixLen = ipv6Addr[1] || 64;
                postData.wan_macAddr = '000000000000';
                
                this.loading = true;
                axios
                .post("/boafrm/fhWANService",postData)
                .then((response)=>{
                    this.loading = false                
                    if(response.data.ret === 0)
                    {
                        this.pingForm.address = '';
                        this.$message.success("Recover is successful!")
                        this.getMacAddress()                    
                    }
                    else
                    {
                        this.$message.error("Recover is failed!")
                    }
                })  
            }
        },
        formatString(str){
            if(str && str.length===12){
                let formattedString = str.substring(0,2)+":"+str.substring(2,4)+":"+str.substring(4,6)+":"+str.substring(6,8)+":"+str.substring(8,10)+":"+str.substring(10,12);
                return formattedString
            }
        }
    },
}
</script>
<style lang="scss" scoped>
.time {
  color: #737373;
  float: left;
}
textarea {
  resize: none;
  width: 100%;
  height: 200px;
}
.panel-heading {
  color: #333;
  background-color: #f5f5f5;
  border-color: #ddd;
  padding: 10px 15px;
  border-bottom: 1px solid transparent;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}
.textb {
  padding: 15px;
}
</style>





